import { Service } from '@roc/feature-app-core';

const url = {
  GENERATE_NOTE_ALLONGE: '/api/v1/loan/splsigning/generateNoteAllongeDocument',
  GENERATE_ASSIGNMENT_CONVEYANCE: '/api/v1/loan/splsigning/generateAssignmentAndConveyanceDocument',
  VALIDATE_SIGNING_DOCUMENT: '/api/v1/loan/splsigning/validateSigningDocument',
  DOWNLOAD_WET_SIGN_DOCUMENT: '/api/v1/loan/splsigning/downloadWetSignDocument',
  GET_WET_SIGN_MAILING_ADDRESS: '/api/v1/loan/splsigning/wetSignMailingAddress',
};

export class DocumentSigningService extends Service {
  generateNoteAllongeDocument(data) {
    return this.post(url.GENERATE_NOTE_ALLONGE, data);
  }

  generateAssignmentAndConveyanceDocument(data) {
    return this.post(url.GENERATE_ASSIGNMENT_CONVEYANCE, data);
  }

  validateSigningDocument(loanId) {
    return this.get(`${url.VALIDATE_SIGNING_DOCUMENT}?loanId=${loanId}`);
  }

  getWetSignMailingAddress() {
    return this.get(url.GET_WET_SIGN_MAILING_ADDRESS);
  }

  downloadWetSignDocument(loanId, documentType: string) {
    return this.get(
      url.DOWNLOAD_WET_SIGN_DOCUMENT,
      { loanId, documentType },
      { responseType: 'arraybuffer' }
    );
  }
}